import { Post } from '@/service/request/server';
import { envConfig } from '@root/env';

const baseUrl = envConfig.formalServer + '/lilliput/admin/map/';

function baseApi() {
    function update(data) {
        return Post(baseUrl + 'update', data);
    }

    function query(data) {
        return Post(baseUrl + 'list', data);
    }

    return {
        query,
        update,
    }
}

export const lilliputApi = baseApi()